<template>
	<div id="appRoot">
		<router-view/>
		<!-- ローディングコンポーネント -->
		<loadingOverlay id="loadingOverlay" :active.sync="isLoading" :enforce-focus="false" ref="overlay"></loadingOverlay>
		<!-- CookiePolicy確認バナー -->
		<CookieBanner></CookieBanner>
	</div>
</template>
<script>
import { computed, defineComponent, onMounted, ref } from '@vue/runtime-core';
import { storeAccessor } from './store/storeAccessor';
import CookieBanner from './components/common/CookieBanner.vue';

export default defineComponent({
    components:{
		CookieBanner
    },
    setup(props, context) { // eslint-disable-line
		const isLoading = computed(function(){
			return storeAccessor.getIsLoading() && storeAccessor.getUseLoadingOverlay();
		});
		const overlay = ref(null);
		onMounted(() => {
			//loadingOverlayの動作中にバックグラウンドの要素がフォーカスを取得するのを阻止する。(vue-loading-overlayの基本機能)
			//ただし、その仕組みがbootstrapのmodalとバッティングする(modalは閉じるボタンにフォーカスを持っていこうとする)ので、
			//vue-loading-overlayの方で「閉じるボタン」への遷移は許容するようにラッピングをしている。
			document.addEventListener('focusin', function(event){
				if(event.target && event.target.classList && event.target.classList.contains("btn-close")){
					return;
				}
				overlay.value.focusIn.call(overlay, event);
			})
		});
		return {
			overlay,
			isLoading,
		};
	}
});
</script>
<style lang="scss">
#appRoot {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin: 0px;
	padding: 0px;
}
table {
	tbody {
		tr {
			&.selected{
				background-color: #87c5fc;
			}
		}
	}
}
input {
	&.vgt-input {
		&:placeholder-shown{
			background-color: #FFFFFF;
		}
		&:not(:placeholder-shown){
			background-color: #ffff80;
		}
	}
}
button{
	&.no-button{
		background-color: transparent;
		border: none;
		outline: none;
		padding: 0;
		appearance: none;
	}
	&.btn-light{
		&.focus,
		&:focus {
			color: initial !important;
			background-color: initial !important;
			border-color: initial !important;
			box-shadow: none !important;
			outline: none !important;
		}
	}
}
// div[class*="-page"]{
// 	padding-top: 3.5em;
// }
.nav-padding{
	padding-top: 3.5em;
	padding-left: 3.5em;
}
.nav-padding-top{
	padding-top: 3.5em;
}
.omit-text-overflow{
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	&.w100{
		max-width: 200px;
	}
	&.w200{
		max-width: 200px;
	}
	&.w300{
		max-width: 300px;
	}
	&.w400{
		max-width: 400px;
	}
	&.hoverable:hover{
		overflow: auto;
		text-overflow: clip;
	}
}
@import 'bootstrap/dist/css/bootstrap';
@import '@/assets/scss/common.scss';

[role=alert]{
	@extend .text-danger;
	display:block;
}
button{
	&.no-button{
		background-color: transparent;
		border: none;
		outline: none;
		padding: 0;
		appearance: none;
	}
	&.btn-light{
		&.focus,
		&:focus {
			color: initial !important;
			background-color: initial !important;
			border-color: initial !important;
			box-shadow: none !important;
			outline: none !important;
		}
	}
}
.expired {
	color : #d0d0d0;
}
.custom-tooltip.tooltip > .tooltip-inner {
  max-width : 500px;
  text-align : left;
}
</style>
